"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var RequestData_1 = __importDefault(require("../../classes/RequestData"));
var event_bus_1 = require("../../event-bus");
var request_1 = __importDefault(require("../../request"));
var echo_1 = __importStar(require("../../echo"));
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var RolesMixin = /** @class */ (function (_super) {
    __extends(RolesMixin, _super);
    function RolesMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.roles = new RequestData_1.default();
        return _this;
    }
    RolesMixin.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.role.create, this.onRoleCreateEvent)
            .$on(event_bus_1.events.role.rename, this.onRoleRenameEvent)
            .$on(event_bus_1.events.role.delete, this.onRoleDeleteEvent);
        echo_1.default.channel(echo_1.channels.role)
            .listen(echo_1.events.role.rename, this.updateRole)
            .listen(echo_1.events.role.create, this.updateRoles)
            .listen(echo_1.events.role.delete, this.requestRoles);
    };
    RolesMixin.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.role.create, this.onRoleCreateEvent)
            .$off(event_bus_1.events.role.rename, this.onRoleRenameEvent)
            .$off(event_bus_1.events.role.delete, this.onRoleDeleteEvent);
        echo_1.default.leave(echo_1.channels.role);
    };
    RolesMixin.prototype.requestRoles = function () {
        return request_1.default.role.all(this.updateRoles);
    };
    RolesMixin.prototype.onRoleCreateEvent = function (role) {
        var _this = this;
        return request_1.default.role.create(role.name, function (role, permissions, roles) {
            _this.updateRoles(roles);
        });
    };
    RolesMixin.prototype.onRoleRenameEvent = function (role) {
        return request_1.default.role.rename(role.id, role.name, this.updateRole);
    };
    RolesMixin.prototype.onRoleDeleteEvent = function (role) {
        var _this = this;
        return request_1.default.role.delete(role.id, function (role, roles) {
            _this.updateRoles(roles);
        });
    };
    RolesMixin.prototype.updateRoles = function (roles) {
        this.roles = this.roles.setArray(roles);
    };
    RolesMixin.prototype.updateRole = function (updatedRole) {
        this.roles = this.roles.updateArray(updatedRole);
    };
    RolesMixin = __decorate([
        vue_class_component_1.default
    ], RolesMixin);
    return RolesMixin;
}(vue_property_decorator_1.Vue));
exports.default = RolesMixin;
